import { c as _c } from "react/compiler-runtime";
import DemodeskMeeting, { DemodeskMeetingScheduledEvent } from "@components/DemodeskMeeting";
import { FC } from "react";
export interface MeetingScheduledEvent {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  time: string;
}
interface MeetingProps {
  onMeetingScheduled: (event: MeetingScheduledEvent) => void;
  demodeskUrl: string;
}
const Meeting: FC<MeetingProps> = t0 => {
  const $ = _c(5);
  const {
    onMeetingScheduled,
    demodeskUrl
  } = t0;
  let t1;
  if ($[0] !== onMeetingScheduled) {
    t1 = event => {
      onMeetingScheduled({
        email: event.data.form.customer_email,
        firstName: event.data.form.customer_first_name,
        lastName: event.data.form.customer_last_name,
        phone: event.data.form.customer_phone,
        time: event.data.meetingDate
      });
    };
    $[0] = onMeetingScheduled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDemodeskMeetingScheduled = t1;
  let t2;
  if ($[2] !== demodeskUrl || $[3] !== handleDemodeskMeetingScheduled) {
    t2 = <DemodeskMeeting onMeetingScheduled={handleDemodeskMeetingScheduled} calendarUrl={demodeskUrl} />;
    $[2] = demodeskUrl;
    $[3] = handleDemodeskMeetingScheduled;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default Meeting;